import { Row, Col, Space, Empty, Typography, Button } from "antd";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import QuizBuilderFooter from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/components/QuizBuilderFooter";
import PickQuestionsTable from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/PickQuestionsTable";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { PlusOutlined } from "@ant-design/icons";

const StyledCol = styled<any>(Col)`
  height: calc(100vh - 200px);
  display: flex;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
const QuizCreation = () => {
  const { generatedQuestion, setGeneratedQuestions, setActive } =
    useQuizContext();
  const [qIdKey, setQIdKey] = useState<any>([]);
  const {
    alreadySelected = [],
    autoPick = [],
    manualPick = [],
  } = generatedQuestion || {};
  const Questions = [...alreadySelected, ...autoPick, ...manualPick];
  useEffect(() => {
    if (Questions.length) {
      console.log("QuestionsQuestions", Questions);
      //   setQIdKey(Questions);
    }
  }, [Questions]);
  const handleRowSelection = (selectedRow: any) => {
    console.log("selectedRowselectedRow", selectedRow);
  };
  const handleAction = (values: any) => {
    const { questionId } = values || {};
    const isAutoPickQuestion = autoPick.some(
      (ele: any) => ele.questionId === questionId
    );
    const isManualQuestion = manualPick.some(
      (ele: any) => ele.questionId === questionId
    );
    const key = isAutoPickQuestion
      ? "autoPick"
      : isManualQuestion
      ? "manualPick"
      : "alreadySelected";
    setGeneratedQuestions((prev: any) => ({
      ...prev,
      [key]: prev[key].filter((ele: any) => ele.questionId != questionId),
    }));
  };
  console.log(
    "generatedQuestiongeneratedQuestion",
    generatedQuestion,
    Questions
  );
  return (
    <Row gutter={24}>
      {Questions.length ? (
        <StyledCol span={24}>
          <Space direction="vertical" style={{ width: "100%" }} size={16}>
            <PickQuestionsTable
              data={Questions}
              pagination={false}
              onSelectChange={handleRowSelection}
              qIdKey={qIdKey}
              setQIdKey={setQIdKey}
              checked={true}
              handleAction={handleAction}
            ></PickQuestionsTable>
          </Space>
        </StyledCol>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center w-100 h-100"
          style={{
            height: "400px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
          }}
        >
          <Empty
            image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
            styles={{ image: { height: 100 } }}
            description={
              <Typography.Text>
                No Questions. Please either generate questions or manual pick
              </Typography.Text>
            }
          >
            <Space>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setActive("1");
                }}
              >
                Generate Question
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setActive("2");
                }}
              >
                Select Manual
              </Button>
            </Space>
          </Empty>
        </div>
      )}

      <QuizBuilderFooter />
    </Row>
  );
};

export default QuizCreation;
